var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('bussines-card-deck',{attrs:{"bussinesList":_vm.bussinesList,"EventBus":_vm.EventBus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }